import { IChildProp } from '@intelligence/components/Form/type';

const GLOBAL_VIEW_DOWNLOAD_SET: IChildProp[] = [
  {
    enumKey: 'SpecialDataCategory',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [
      {
        enumKey: 'totalMarket',
        enumTargetType: 'gameCategory',
        defaultSelectCondition: 'additionalFields:revenueType:total',
      },
      {
        enumKey: 'mobileGame',
        enumTargetType: 'gameCategory',
        defaultSelectCondition: 'additionalFields:revenueType:mobile',
      },
      {
        enumKey: 'pcGame',
        enumTargetType: 'gameCategory',
        defaultSelectCondition: 'additionalFields:revenueType:pc',
      },
      {
        enumKey: 'consoleGame',
        enumTargetType: 'gameCategory',
        defaultSelectCondition: 'additionalFields:revenueType:console',
      },
    ],
  },
  {
    enumKey: 'dataCalculation',
    enumTargetType: 'downloadMainCategory',
    type: 'subForm',
    className: 'form-item--top-18',
    children: [
      {
        enumKey: 'timeSettings',
        enumTargetType: 'downloadMainCategory',
        type: 'radio',
        children: [
          {
            enumKey: 'isTimeAggregated',
            enumTargetType: 'downloadDataCalcu',
            isDefault: true,
          },
          {
            enumKey: 'isSeparateByTime',
            enumTargetType: 'downloadDataCalcu',
          },
        ],
      },
      {
        enumKey: 'marketSettings',
        enumTargetType: 'downloadMainCategory',
        type: 'checkboxGroup',
        children: [
          {
            enumKey: 'isRegion',
            enumTargetType: 'downloadDataCalcu',
            isDefault: true,
            disableCondition: 'additionalFields:perType:market&&additionalFields:filterType:market',
          },
          {
            enumKey: 'isCoreMarkets',
            enumTargetType: 'downloadDataCalcu',
            isDefault: true,
            disableCondition: 'additionalFields:perType:market&&additionalFields:filterType:region',
          },
        ],
      },
      {
        enumKey: 'ratio',
        enumTargetType: 'downloadMainCategory',
        type: 'switch',
        isDefault: true,
        condition: 'additionalFields:isDodHide:false',
      }
    ],
  },
  {
    enumKey: 'otherSettings',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [
      {
        enumKey: 'exportAllData',
        enumTargetType: 'downloadOther',
        isDefault: true,
      },
      {
        enumKey: 'selectTop',
        enumTargetType: 'downloadOther',
      },
    ],
  },
  {
    enumKey: 'selectTop',
    enumTargetType: 'downloadMainCategory',
    type: 'inputNumber',
    // 默认值，带?为变量传入，不带为正常值
    defaultValue: '?additionalFields:initialSelectTop',
    condition: 'dataAmount:top',
  },
  {
    enumKey: 'fileFormat',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [
      {
        isDefault: true,
        enumKey: 'exportExcel',
        enumTargetType: 'downloadOther',
      },
      {
        enumKey: 'exportCSV',
        enumTargetType: 'downloadOther',
      },
    ],
  },
];

export default {
  globalView: GLOBAL_VIEW_DOWNLOAD_SET
};
